import React from 'react';

function NoReservations() {
  return (
    <div>
      <div className="reservation-message">
        Momentálně nemáte žádné rezervace.
      </div>
    </div>
  );
}

export default NoReservations